import { SuppliersList } from "./SuppliersProperties";

export class OfflineSupplierProperties {
  offlineSupplierId: string;
  offlineSupplierName: string;
  offlineProviderCode: string;
  isActive: boolean = false;
  agencyId: string = '';
  userId: string = '';
  officeSupplierList: OfflineSupplierOfficeProperties[];


}

export class OfflineSuppAndOfflineOfficeProperties {
  offlineSupplier: OfflineSupplierProperties[]=[];

}

export class OfflineSupplierOfficeProperties {
  offlineOfficePccId: number = 0;
  offlinePcc: string="";
  backOfficeCompany: string ="";
  backOfficeSupplier: string="";
  currency: string="";
  isActive: boolean = false;
  offlineSupplierId: string;
  supplierCodesList: SuppliersList[] = [];
}
